<div class="contenedor-bloque-destacados" id="contenedor-bloque-destacados" [style]="{ '--background-color-bloque': configBloque.color_fondo, '--color-texto-bloque': configBloque.color_texto }">
  <div class="titulo-destacado">Es noticia</div>
  <div class="noticias-destacadas" #divNoticiasDestacadas id="divNoticiasDestacadas" (touchend)="initInterval()" (mouseleave)="initInterval()">
    <span *ngFor="let item of noticiasDestacadas; trackBy: trackByNoticia">
      <a [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]" title="{{ item.tituloVideo }}">
        {{ item.tituloVideo.length > 50 ? (item.tituloVideo | slice: 0 : 50) + "..." : item.tituloVideo }}
      </a>
    </span>
  </div>
</div>
